import Image from 'next/image'

import checkSVG from '@/assets/svgs/check.svg'
import clockSVG from '@/assets/svgs/clock.svg'
import commentSVG from '@/assets/svgs/comment.svg'
import dumbellSVG from '@/assets/svgs/dumbell.svg'
import penSVG from '@/assets/svgs/edit-2.svg'

const CardOnboarding = ({
  icon,
  title,
}: {
  icon: 'clock' | 'comment' | 'edit' | 'dumbell'
  title: string
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'clock':
        return clockSVG
      case 'comment':
        return commentSVG
      case 'edit':
        return penSVG
      case 'dumbell':
        return dumbellSVG
      default:
        return clockSVG
    }
  }

  return (
    <div className="flex items-center justify-between rounded-lg bg-[#F4F4F5] px-5 py-4">
      <div className="flex items-center gap-4">
        <Image src={getIcon()} alt={`${icon} icon`} width={20} height={20} />
        <span className="font-outfit text-sm font-medium leading-5 text-[#000]">
          {title}
        </span>
      </div>
      <Image src={checkSVG} alt="check icon" width={20} height={20} />
    </div>
  )
}

export default CardOnboarding
